import { chromatographyMnemonics, MNEMONICS } from 'constants/mnemonics';
import { DataConsistencyDTO } from 'types/dataConsistency';
import { MnemonicsMappingDTO } from 'types/mnemonicsMapping';

export const getFlowCorrelationIndex = (dataConsistency?: DataConsistencyDTO) => {
  if (dataConsistency?.flowCorrelation === undefined) return 0;

  return dataConsistency?.flowCorrelation < 0.8 ? 0 : 1;
};

export const getTrajectorySurveyRatio = (dataConsistency?: DataConsistencyDTO) => {
  if (dataConsistency?.trajectoryRate === undefined) return 0;

  return dataConsistency.trajectoryRate < 1
    ? 0
    : dataConsistency.trajectoryRate < 2
    ? Math.round((dataConsistency?.trajectoryRate - 1) * 100) / 100
    : 1;
};

export const getTrajectorySurveyHole = (dataConsistency?: DataConsistencyDTO) => {
  if (dataConsistency?.trajectoryMax === undefined) return 0;

  return dataConsistency.trajectoryMax > 300
    ? 0
    : dataConsistency.trajectoryMax > 50
    ? Math.round((6 / 5 - dataConsistency.trajectoryMax / 250) * 100) / 100
    : 1;
};

export const getDepthCheck = (dataConsistency?: DataConsistencyDTO) => {
  if (dataConsistency?.depthOutliers === undefined) return 1;

  return dataConsistency.depthOutliers > 10 ? 0 : 1;
};

export const getBitDepthCheck = (dataConsistency?: DataConsistencyDTO) => {
  if (dataConsistency?.bitdepOutliers === undefined) return 1;

  return dataConsistency.bitdepOutliers > 10 ? 0 : 1;
};

export const getChromatoCheck = (mnemonicsMapping?: MnemonicsMappingDTO) => {
  const chromatoIndexReducer = (
    accumulator: number,
    currentValue: { mnemonic: string; label: string },
  ) => {
    if (!mnemonicsMapping?.timeData?.[currentValue.mnemonic]?.live) return accumulator + 0;
    if (currentValue.label === 'C1' || currentValue.label === 'C2' || currentValue.label === 'C3') {
      return accumulator + 2;
    }

    return accumulator + 1;
  };

  return chromatographyMnemonics.reduce(chromatoIndexReducer, 0) / 10;
};

export const getBoosterCheck = (mnemonicsMapping?: MnemonicsMappingDTO) => {
  return mnemonicsMapping?.timeData[MNEMONICS.FLOWIN_BST]?.live ? 1 : 0;
};

export const computeDataConsistencyIndex = (
  isFlowInBstNA: boolean,
  dataConsistency?: DataConsistencyDTO,
  mnemonicsMapping?: MnemonicsMappingDTO,
) => {
  const flowCorrelationIndex = getFlowCorrelationIndex(dataConsistency);
  const trajectoryCheckIndex =
    (getTrajectorySurveyRatio(dataConsistency) + getTrajectorySurveyHole(dataConsistency)) / 2;
  const depthCheckIndex = (getDepthCheck(dataConsistency) + getBitDepthCheck(dataConsistency)) / 2;
  const chromatoCheck = getChromatoCheck(mnemonicsMapping);

  if (isFlowInBstNA === true) {
    return (
      Math.round(
        (flowCorrelationIndex + trajectoryCheckIndex + depthCheckIndex + chromatoCheck) * 25,
      ) / 100
    );
  }

  const boosterCheckIndex = getBoosterCheck(mnemonicsMapping);

  return (
    Math.round(
      (flowCorrelationIndex +
        boosterCheckIndex +
        trajectoryCheckIndex +
        depthCheckIndex +
        chromatoCheck) *
        20,
    ) / 100
  );
};
